var $popupBtns = $('.js-popup-btn');
var $nav = $('#z-nav'),
    $header = $('.header-main'),
	$hamburger = $('.js-toggle-nav');

class Popups {
	constructor($btns) {
		this.$btns = $btns;
	}

	init() {
		let self = this;

		this.$btns
			.on('click', function(e) {
				e.preventDefault();
				let selector = $(this).data('popup-selector');
				self.closeNav();
				if ($(this).hasClass('is-opened')) {
					self.closePopup(selector);
				} else {
					self.closePopups();
					self.openPopup(selector);
				}
			});

		$(document)
			.on('click', '.popup__close, .hamburger, .js-tippy', (e) => {
				e.preventDefault();
				self.closePopups();
			});
	}

	closeNav () {
		$('body').toggleClass('nav--opened');
		$header.toggleClass('nav--opened');
		$hamburger.toggleClass('is-active');
		$nav.toggleClass('is-open');
	}

	closePopups() {
		$('.js-popup-container').hide();
		$(`.js-popup-btn`).removeClass('is-opened');
		$('body').css({
			"position": "static",
			"overflow-y": "auto"
		})
	}

	closePopup(selector) {
		$(selector).hide();
		$(`.js-popup-btn[data-popup-selector="${selector}"]`).removeClass('is-opened');
		$('body').css({
			"position": "static",
			"overflow-y": "auto"
		})
	}

	openPopup(selector) {
		$(selector).show();
		$(`.js-popup-btn[data-popup-selector="${selector}"]`).addClass('is-opened');
		window.scrollTo(0,0);
		$('body').css({
			"position": "fixed",
			"overflow-y": "scroll"
		})
	}
}

if ($popupBtns.length) {
	let popups = new Popups($popupBtns);
	popups.init();
}


// NEED TEST AND REFACTORING
// if ($('.js-z-page-nav-popup__item').length) {
// 	$('.js-z-page-nav-popup__btn').on('click', function () {
// 		if ($(this).hasClass('opened')) {
// 			$('.js-z-page-nav-popup__container').hide();
// 			$(this).removeClass('opened');
// 		} else {
// 			$('.js-z-page-nav-popup__container').show();
// 			$(this).addClass('opened');
// 		}
// 	});

// 	$(document).on('click', function (e) {
// 		if (!$(e.target).hasClass('js-z-page-nav-popup__item')) {
// 			$('.js-z-page-nav-popup__container').hide();
// 			$('.js-z-page-nav-popup__btn').removeClass('opened');
// 		}
// 	});
// }

$('.header-top-list__link--search').on('click', function() {
	$('#search-field').focus();
})



// WEBPACK FOOTER //
// ./frontend/components/popup/popup.js